import { render, staticRenderFns } from "./SongWrapper.vue?vue&type=template&id=1f600e6e&"
import script from "./SongWrapper.vue?vue&type=script&lang=js&"
export * from "./SongWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SongWrapper.vue?vue&type=style&index=0&id=1f600e6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports